<template>
  <v-container
    fluid
    dark
    class="mt-12 mb-12"
    :style="'overflow-y: scroll; max-height: 100%;'"
  >
    <v-row v-if="$store.getters.cartSize < 1">
      <v-col cols="12" class="d-flex justify-center">
        <span class="text-center text-h6">Twój koszyk jest pusty</span>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn class="mt-2" block @click="goToProducts()"
          ><v-icon :style="'color: green;'">fas fa-store</v-icon>&nbsp;Przejdź
          do produktów</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" v-if="!this.$vuetify.breakpoint.mobile">
        <v-row>
          <v-col cols="12">
            <v-simple-table dark>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">#</th>
                    <th class="text-left">Zdjęcie</th>
                    <th class="text-left">Nazwa</th>
                    <th class="text-left">Cena</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in $store.state.cart"
                    :key="item.label"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <v-img
                        :src="`/api/products/image?id=${item.id}`"
                        elevation="1"
                        :style="'max-height:100px; max-width: 100px;'"
                        class="rounded thumbnail-static"
                      >
                      </v-img>
                    </td>
                    <td>{{ item.label }}</td>
                    <td>{{ item.price }}{{ $store.state.currency }}</td>
                    <td>
                      <v-btn
                        icon
                        :loading="cartLoading"
                        @click="deleteFromCart(item.id)"
                      >
                        <v-icon>fas fa-trash-alt</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td></td>
                    <td></td>
                    <td>Wysyłka</td>
                    <td>9zł</td>
                    <td></td>
                  </tr> -->
                  <tr>
                    <td></td>
                    <td></td>
                    <td class="text-h6 text-blue">SUMA</td>
                    <td class="text-h6" :style="'color: #00df23 !important;'">
                      {{ $store.getters.cartTotal }}{{ $store.state.currency }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn class="mt-2" dark @click="goToOrder()"
              ><v-icon :style="'color: green;'">fas fa-store</v-icon
              >&nbsp;Przejdź do zamówienia</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-else>
        <v-row>
          <v-col
            v-for="item in $store.state.cart"
            :key="item.label"
            :class="'col-12'"
          >
            <v-card class="mx-auto" max-width="100%" dark>
              <v-img
                :src="`/api/products/image?id=${item.id}`"
                height="100%"
              ></v-img>

              <v-card-title>
                <span class="text-subtitle-2">{{ item.label }}</span>
              </v-card-title>
              <v-card-title class="pt-0 pb-0">
                <span class="text-subtitle-2">{{ item.price }}{{ $store.state.currency }}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions class="d-flex justify-end">
                <v-btn light @click="deleteFromCart(item.id)">
                  <v-icon>fas fa-trash-alt</v-icon>&nbsp;Usuń z koszyka
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" class="">
            <v-card dark block>
              <!-- <v-card-title class="d-flex justify-end">
                <span class="text-subtitle-2">Wysyłka: 9zł</span>
              </v-card-title> -->
              <v-card-title class="d-flex justify-end">
                <span class="text-subtitle-2"
                  >SUMA:
                  <span :style="'color: #00df23 !important;'"
                    >{{ $store.getters.cartTotal + 9 }}{{ $store.state.currency }}</span
                  ></span
                >
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-btn class="mt-2" dark block @click="goToOrder()"
              ><v-icon :style="'color: green;'">fas fa-store</v-icon
              >&nbsp;Przejdź do zamówienia</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CartView",
  data: () => ({
    cartLoading: false,
  }),
  methods: {
    goToOrder: function () {
      this.$router.push("/zamowienie");
    },
    goToProducts: function () {
      this.$router.push("/produkty");
    },
    deleteFromCart: function (id) {
      this.cartLoading = true;
      this.$axios
        .post("/api/cart/delete", {
          id: id,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.$store.commit("setCart", response.data.cart);
            this.cartLoading = false;
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">Błąd podczas usuwania produktu!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.cartLoading = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas usuwania produktu!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.cartLoading = false;
          console.log(error);
        });
    },
  },
  components: {},
};
</script>

<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
